module.exports = __webpack_public_path__ + "static/7-ab41bf709610454f891722a5707080dd.jpeg";